import { Box, Stepper, theme } from '@capitalise/ui-design-system';
import useMediaQuery from 'modules/Business/hooks/useMediaQuery';
import Skeleton from 'react-loading-skeleton';
import { slideRightCss, StyledHr } from '../styled';
import PropTypes from 'prop-types';

const MatchCardSkeleton = ({ index }) => {
  const { isMobile } = useMediaQuery();

  return (
    <Box
      p={isMobile ? 'small' : 'medium'}
      backgroundColor="white"
      borderRadius={theme.sizes['xsmall']}
      marginBottom="3xsmall"
      css={slideRightCss(index)}
      aria-label="Loading match"
    >
      <Box
        display="grid"
        gridTemplateColumns={isMobile ? '1fr' : '1fr 3fr 1fr'}
        alignItems="center"
        gridGap="4xsmall"
      >
        <Skeleton width={120} height={96} />
        <Stepper steps={['', '', '', '', '', '', '', '']} loading currentStep={0} />
      </Box>

      <Box display="flex" alignItems="center" justifyContent="space-between" marginY="xsmall">
        <Box borderRadius={theme.sizes['xsmall']} width="30%">
          <Skeleton />
        </Box>
        <Box flex="1" pl="3xsmall">
          <StyledHr />
        </Box>
      </Box>

      <Box
        display="grid"
        gridTemplateColumns={isMobile ? '1fr' : '1fr 3fr 1fr'}
        alignItems="center"
        gridGap="4xsmall"
      >
        <Box borderRadius={theme.sizes['xsmall']}>
          <Skeleton />
        </Box>
        <Box borderRadius={theme.sizes['xsmall']}>
          <Skeleton />
        </Box>
      </Box>
    </Box>
  );
};

MatchCardSkeleton.propTypes = {
  index: PropTypes.number.isRequired,
};

export default MatchCardSkeleton;
